<template>
  <section class="content">
    <div class="box box-info">
      <UnitConversionDialog ref="unitConvDialog"/>
      <div class="p-card-body">
        <DataTable
          :value="unitConversionLists"
          :paginator="true"
          :rows="10"
          class="p-datatable-responsive p-datatable-gridlines"
          data-key="id"
        >
          <Column header="S.N"/>
          <Column header="Name" field="name" filterField="name" filterMatchMode="contains"/>
          <Column header="Unit From" field="unitFrom.shortName" filterField="unitFrom" filterMatchMode="contains"/>
          <Column header="Unit Value" field="unitFromValue" filterField="unitFromValue" filterMatchMode="contains"/>
          <Column header="Unit To" field="unitTo.shortName" filterField="unitTo" filterMatchMode="contains"/>
          <Column header="Unit Value" field="unitToValue" filterField="unitToValue" filterMatchMode="contains"/>
          <Column header="Action">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                      @click="editUnitConversion(slotProps.data)"/>
              <Button class="p-button-raised p-button-danger" icon="pi pi-trash"
                      @click="openDialog(slotProps.data.id)"/>
            </template>
          </Column>
        </DataTable>
        <DeleteDialog v-model="dialogShow" @cancel="cancel" @deleted="deleteUnitConversion"/>
      </div>
    </div>
  </section>
</template>

<script>
import UnitConversionDialog from '../itemDialog/UnitConversionDialog'
import DataTable from 'primevue/datatable'
import Button from 'primevue/button'
import Column from 'primevue/column'
import DeleteDialog from '../../layout/dialog'

export default {
  name: 'UnitConversions',
  data() {
    return {
      dialogShow: false,
      deleteReason: '',
      conversionId: ''
    }
  },
  computed: {
    unitConversionLists() {
      return this.$store.state.itemgroup.unitConversionLists
    }
  },
  mounted() {
    this.unitConversionList()
  },
  methods: {
    async unitConversionList() {
      await this.$store.dispatch('loadUnitConversionList')
    },
    editUnitConversion(data) {
      this.$refs.unitConvDialog.editUnitConversion(data)
    },
    async deleteUnitConversion(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 3000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        conversionId: this.conversionId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteUnitConversion', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      }
      this.closeDialog()
    },
    cancel() {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.conversionId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Button,
    Column,
    UnitConversionDialog,
    DeleteDialog
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UnitConversions.vue?7088056a